export default __webpack_public_path__ + "static/media/teamMember1.c145c26a.png";